// Pixels API. Always under /api (performRequest prefixes it): the bare
// /pixels path would be captured by nginx's /pixel prefix and sent to the
// serving pool. Nothing here ever calls a /data/ path except /data/status.
const asList = (res) => {
  if (Array.isArray(res)) return { items: res, nextCursor: null };
  const items = res?.items ?? res?.rows ?? res?.data ?? [];
  return {
    items: Array.isArray(items) ? items : [],
    nextCursor: res?.nextCursor ?? null,
  };
};

export const createPixelsApi = (performRequest) => ({
  async list({ owner, limit = 25, cursor } = {}) {
    const params = new URLSearchParams({ limit: String(limit) });
    if (owner) params.set("owner", owner);
    if (cursor) params.set("cursor", cursor);
    return asList(await performRequest(`/pixels?${params}`));
  },
  get: (id) => performRequest(`/pixels/${encodeURIComponent(id)}`),
  create: (body) =>
    performRequest("/pixels", { method: "POST", body: JSON.stringify(body) }),
  update: (id, body) =>
    performRequest(`/pixels/${encodeURIComponent(id)}`, {
      method: "PUT",
      body: JSON.stringify(body),
    }),
  remove: (id) =>
    performRequest(`/pixels/${encodeURIComponent(id)}`, { method: "DELETE" }),
  stats: (id, from, to) => {
    const params = new URLSearchParams({
      from: from.toISOString(),
      to: to.toISOString(),
    });
    return performRequest(`/pixels/${encodeURIComponent(id)}/stats?${params}`);
  },
  status: (id) =>
    performRequest(`/data/status?${new URLSearchParams({ pixelUuid: id })}`),
});
